module.exports = __webpack_public_path__ + "img/google_login.d66762e3.svg";